import {get} from "lodash"

import API from "@irati/utils/services/API"
import endpoints from "@irati/utils/endpoints"
import authentication from "@irati/auth"

/**
 *  @private
 *  @notes Helper to return the tenant id
 *  @returns {string|null}
 */

const _getTenantId = () => get(authentication.userTenant(), "uuid")

export const getPerksSettings = () => {
  return API.get(`${endpoints.settings}/${_getTenantId()}`)
    .then((res) => res.data.settings)
}
